import apiClient from '../utils/apiClient';

export async function updatePersonalInfo(userId, data) {
  const response = await apiClient.put('/api/profile/personal-info', data);
  return response.data;
}

export async function updatePassword(passwordData) {
  const response = await apiClient.put('/api/profile/password', passwordData);
  return response.data;
}

export async function uploadAvatar(userId, file) {
  const formData = new FormData();
  formData.append("avatar", file);

  const response = await apiClient.post('/api/profile/avatar', formData);
  return response.data;
}

export async function getNotificationPreferences() {
  const response = await apiClient.get('/api/profile/notifications');
  return response.data;
}

export async function updateNotificationPreferences(preferences) {
  const response = await apiClient.put('/api/profile/notifications', { preferences });
  return response.data;
}